module.exports = __webpack_public_path__ + "img/title-5.82b407c2.png";